/**
 * quantity-break-thumb.js
 * Standalone, self-contained script.
 * Updates the small variant thumbnail image next to each per-unit colour
 * dropdown inside the "Bundle & Save" quantity-break pricing tiers, live,
 * as soon as the shopper changes a dropdown selection.
 *
 * This file does NOT modify or depend on main.js in any way — it only
 * listens for the native "change" event that already fires on
 * .quantity-break__variant-select elements, then swaps the matching
 * .quantity-break__variant-thumb <img> next to it using a data-image
 * attribute already present on each <option> (rendered server-side by
 * Liquid). If that attribute or the thumbnail element are ever removed,
 * this script simply does nothing — it cannot break add-to-cart,
 * checkout, or any other theme behaviour.
 */
(function () {
  'use strict';

  function updateThumbFromSelect(selectEl) {
    if (!selectEl || selectEl.tagName !== 'SELECT') return;

    var selectedOption = selectEl.options[selectEl.selectedIndex];
    if (!selectedOption) return;

    var imageUrl = selectedOption.getAttribute('data-image');
    if (!imageUrl) return;

    // The thumbnail lives as a sibling inside the same
    // .quantity-break__selector-item container.
    var container = selectEl.closest('.quantity-break__selector-item');
    if (!container) return;

    var thumb = container.querySelector('.quantity-break__variant-thumb');
    if (!thumb) return;

    if (thumb.getAttribute('src') !== imageUrl) {
      thumb.setAttribute('src', imageUrl);
    }
  }

  function handleChange(event) {
    var target = event.target;
    if (!target || !target.classList) return;
    if (!target.classList.contains('quantity-break__variant-select')) return;
    updateThumbFromSelect(target);
  }

  function init() {
    // Event delegation on document so this keeps working for any
    // dynamically re-rendered quantity-break markup (e.g. tier switches),
    // without needing to re-bind listeners.
    document.addEventListener('change', handleChange, true);

    // Set correct initial thumbnails on page load, in case the
    // server-rendered default doesn't match the first <option>'s image
    // (e.g. any pre-selected variant edge case).
    document
      .querySelectorAll('.quantity-break__variant-select')
      .forEach(updateThumbFromSelect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
